import React from 'react'
import { observer } from 'mobx-react-lite'

import { TextField } from '@mxenabled/mxui'

import { useAnalyticsStore } from '../../common/context/hooks'
import { useGlobalCopyStore } from '../../common/context/hooks'

const OpenTextField = () => {
  const { response, setResponse } = useAnalyticsStore()
  const { analytics: copy } = useGlobalCopyStore()

  return (
    <TextField
      label={copy.feedback}
      multiline={true}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setResponse(event.target.value)
      }}
      placeholder={copy.improve_experience}
      rows={4}
      value={response ?? ''}
    />
  )
}

export default observer(OpenTextField)
